import { createContext } from 'react';

export interface ToolCallSummaryField {
  label: string;
  value: string;
}

export interface ToolCallInfo {
  name: string;
  label: string;
  arguments: Record<string, unknown>;
  summary?: Array<ToolCallSummaryField> | null;
}

export interface ChatMessage {
  role: 'user' | 'assistant' | 'system';
  content: string;
  toolCalls?: Array<ToolCallInfo>;
  responseId?: string;
}

export interface ChatConversation {
  id: string;
  customerName: string | null;
  customerId: string | null;
  orderId: string | null;
  department?: string | null;
  messages: Array<ChatMessage>;
  lastActivityAt: number;
  createdAt: number;
}

export const GENERAL_CONVERSATION_ID = 'general';

export interface AiChatState {
  isOpen: boolean;
  conversations: Record<string, ChatConversation>;
  activeConversationId: string | null;
  activeConversation: ChatConversation | null;
  isLoading: boolean;
  error: string | null;
  currentUrlCustomerId: string | null;
  currentUrlOrderId: string | null;
}

export interface AiChatActions {
  openChat: (options?: { customerId?: string; customerName?: string }) => void;
  closeChat: () => void;
  sendMessage: (content: string) => void;
  clearChat: () => void;
  switchConversation: (conversationId: string) => void;
  deleteConversation: (conversationId: string) => void;
}

export type AiChatContextType = AiChatState & AiChatActions;

export const AiChatContext = createContext<AiChatContextType | null>(null);
